import { render, staticRenderFns } from "./ApplicationCopy.vue?vue&type=template&id=8d9da08e"
import script from "./ApplicationCopy.vue?vue&type=script&lang=js"
export * from "./ApplicationCopy.vue?vue&type=script&lang=js"
import style0 from "./ApplicationCopy.vue?vue&type=style&index=0&id=8d9da08e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports